import React from "react";
import { IoIosWarning } from "react-icons/io";
import ProgramMiniCard from "./ProgramMiniCard";
import { DateTime } from "luxon";
import { getFieldText } from "../../scripts/helperScripts";

const ProgramRadioSelect = ({
  program,
  careplan,
  selected,
  onChange,
  history,
  ...rest
}) => {
  return (
    <div className="row" onClick={onChange} {...rest}>
      <div className="col-auto">
        <input
          style={{ marginRight: "10px", paddingTop: "40px" }}
          key={program.ccx_client_programid}
          type="radio"
          id={program.ccx_client_programid}
          name="programs"
          value={program.ccx_client_programid}
          checked={
            program.ccx_client_programid === selected.ccx_client_programid
          }
          onChange={onChange}
        />
      </div>
      <div className="col">
        <ProgramMiniCard
          key={program.ccx_client_programid}
          careplan={careplan}
          clientProgram={program}
          history={history.filter((h) =>
            program.ccx_client_programid.includes(h.ClientProgramId)
          )}
          headerTooltip={
            DateTime.fromISO(getFieldText(program.ccx_admitdate)) >=
              DateTime.fromISO("2025-04-01") &&
            program.ccx_name.includes("Mobile Crisis Response") &&
            !program.crisisReferral ? (
              <div className="col-auto text-danger">
                <IoIosWarning title="Missing Crisis Referral" size="1.25em" />
              </div>
            ) : null
          }
        />
      </div>
    </div>
  );
};

export default ProgramRadioSelect;
